<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{ sectionclass }}"
	>
		<!-- style="background: #cdcdcd !important; height: 100%;" -->
		<div *ngIf="hasLiftData; else noLiftDataBlock" class="set_background_color">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>

			<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content stats_content lift_details_row">
				<div class="o-stack o-stack--center _u-px-small lift_stats">
					<!--  style="text-align: center"-->
					<div class="o-stack__cell content_mainCls text_align_center content_mainClas_Lift_Row">
						<img
							class="imageTile"
							src="/assets/images/Lift.png"
							*ngIf="
								version !== 'r7' &&
								version !== 'r8' &&
								directoryName !== 'default-r102' &&
								directoryName !== 'default-r104'
							"
							alt="lift"
							width="80"
						/>
						<svg
							*ngIf="directoryName == 'default-r104'"
							width="66"
							height="66"
							viewBox="0 0 66 66"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M39.6667 46.3333H52.3333C56.067 46.3333 57.934 46.3333 59.36 45.6067C60.6143 44.9677 61.6343 43.9477 62.2733 42.6933C63 41.2673 63 39.4003 63 35.6667V13.6667C63 9.933 63 8.06613 62.2733 6.64007C61.6343 5.38563 60.6143 4.36577 59.36 3.72663C57.934 3 56.067 3 52.3333 3H23.6667C19.933 3 18.0661 3 16.6401 3.72663C15.3856 4.36577 14.3658 5.38563 13.7266 6.64007C13.0446 7.97863 13.0027 9.7055 13.0002 13M53 13L36.3333 29.6667L26.3333 19.6667M53 13V23M53 13H43M23 33C23 36.682 20.0152 39.6667 16.3333 39.6667C12.6514 39.6667 9.66667 36.682 9.66667 33C9.66667 29.318 12.6514 26.3333 16.3333 26.3333C20.0152 26.3333 23 29.318 23 33ZM16.3333 49.6667C19.4332 49.6667 20.9832 49.6667 22.2549 50.0073C25.7058 50.932 28.4013 53.6277 29.326 57.0783C29.6667 58.35 29.6667 59.9 29.6667 63H3C3 59.9 3 58.35 3.34073 57.0783C4.2654 53.6277 6.9609 50.932 10.4118 50.0073C11.6835 49.6667 13.2334 49.6667 16.3333 49.6667Z"
								stroke="#027DA8"
								stroke-width="5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<img class="imageClass" src="/assets/images/lift_R7.svg" *ngIf="version === 'r7'" alt="lift" width="80" />
						<img
							class="imageClass"
							style="height: 62px; width: auto"
							src="/assets/images/lift_r102.svg"
							*ngIf="directoryName === 'default-r102'"
							alt="lift"
							width="80"
						/>
						<img class="imageClass" src="/assets/images/lift_r8.svg" *ngIf="version === 'r8'" alt="lift" width="50" />
						<!--  style="display: block; font-size: 1.5em; font-weight: bold" -->
						<span class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data" *ngIf="liftStatsData"
							>{{ liftStatsData.digitalLift }}x</span
						>
						<!--  style="display: block; font-size: 0.75em;"  -->
						<span class="list_stats_name">Digital Lift</span>
					</div>
					<!-- style="text-align: center" -->
					<div class="o-stack__cell content_mainCls text_align_center content_mainClas_Lift_Row">
						<img
							class="imageTile"
							src="/assets/images/exposed.png"
							*ngIf="
								version !== 'r7' &&
								version !== 'r8' &&
								directoryName !== 'default-r102' &&
								directoryName !== 'default-r104'
							"
							alt="exposed"
							width="80"
						/>
						<svg
							*ngIf="directoryName == 'default-r104'"
							width="66"
							height="50"
							viewBox="0 0 66 50"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								id="Vector"
								d="M42.4304 25.0075C42.4304 30.2166 38.2078 34.4392 32.9986 34.4392C27.7897 34.4392 23.5669 30.2166 23.5669 25.0075C23.5669 19.7983 27.7897 15.5757 32.9986 15.5757C38.2078 15.5757 42.4304 19.7983 42.4304 25.0075Z"
								stroke="#027DA8"
								stroke-width="5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								id="Vector_2"
								d="M33 3C18.9226 3 7.00624 12.2522 3 25.0075C7.00618 37.7627 18.9226 47.015 33 47.015C47.0773 47.015 58.9937 37.7627 63 25.0075C58.9937 12.2523 47.0773 3 33 3Z"
								stroke="#027DA8"
								stroke-width="5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<img
							class="imageTile"
							src="/assets/images/exposed_r8.svg"
							*ngIf="version === 'r8'"
							alt="exposed"
							width="80"
						/>
						<img
							class="imageClass"
							src="/assets/images/exposed_R7.svg"
							*ngIf="version === 'r7'"
							alt="exposed"
							width="80"
						/>
						<img
							class="imageClass"
							src="/assets/images/exposed_r102.svg"
							*ngIf="directoryName === 'default-r102'"
							alt="exposed"
							width="80"
						/>
						<!-- style="display: block; font-size: 1.5em; font-weight: bold" -->
						<span class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data" *ngIf="liftStatsData"
							>{{ liftStatsData.exposedRate }}%</span
						>
						<!-- style="display: block; font-size: 0.75em;" -->
						<span class="list_stats_name_ExpRate">Exposed Rate</span>
					</div>
					<!-- style="text-align: center" -->
					<div class="o-stack__cell content_mainCls text_align_center content_mainClas_Lift_Row">
						<img
							class="imageTile"
							src="/assets/images/baseline.png"
							*ngIf="
								version !== 'r7' &&
								version !== 'r8' &&
								directoryName !== 'default-r102' &&
								directoryName !== 'default-r104'
							"
							alt="baseline"
							width="80"
						/>
						<svg
							*ngIf="directoryName == 'default-r104'"
							width="66"
							height="63"
							viewBox="0 0 66 63"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M4.70398 3L61.2947 59.5908M26.2219 24.736C24.5788 26.4336 23.5676 28.7463 23.5676 31.2954C23.5676 36.5046 27.7904 40.7272 32.9993 40.7272C35.5852 40.7272 37.9281 39.6866 39.6318 38.0014M15.7077 14.4664C9.73648 18.4063 5.18824 24.3283 3 31.2954C7.00616 44.0507 18.9226 53.3029 32.9999 53.3029C39.2529 53.3029 45.0796 51.4776 49.9759 48.3305M29.8554 9.44315C30.8897 9.34046 31.9389 9.28787 32.9999 9.28787C47.0775 9.28787 58.994 18.5402 63 31.2954C62.1175 34.1061 60.8505 36.7464 59.2612 39.1552"
								stroke="#027DA8"
								stroke-width="5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<img
							class="imageClass"
							src="/assets/images/baseline_r8.svg"
							*ngIf="version === 'r8'"
							alt="baseline"
							width="80"
						/>
						<img
							class="imageClass"
							src="/assets/images/baseline_R7.svg"
							*ngIf="version === 'r7'"
							alt="baseline"
							width="80"
						/>
						<img
							class="imageClass"
							src="/assets/images/baseline_r102.svg"
							*ngIf="directoryName === 'default-r102'"
							alt="baseline"
							width="80"
						/>
						<!-- style="display: block; font-size: 1.5em; font-weight: bold" -->
						<span class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data" *ngIf="liftStatsData"
							>{{ liftStatsData.baseLineRate }}%</span
						>
						<!-- style="display: block; font-size: 0.75em;" -->
						<span class="list_stats_name">Baseline Rate</span>
					</div>
				</div>
				<!-- style="font-size: 1.2em; padding: 2em 0em 0.8em !important;" -->
				<div class="set_padding_r5"></div>
				<div class="content_mainCls content_mainClas_Lift_Row lift_stats_subsection lift_stats_subtitle">
					People who saw your digital ads were
					<b>
						<span *ngIf="liftStatsData">{{ liftStatsData.digitalLift }}</span> times more likely to visit your website
					</b>
					than the unexposed audience.
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div
					class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{
						sectionclass
					}}"
				>
					<!-- style="background: #cdcdcd !important; height: 100%;" -->
					<div class="set_background_color">
						<div
							class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
						>
							<div class="o-stack__cell">
								<h5>{{ sectiontitle }}</h5>
							</div>
						</div>
					</div>
				</div>
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
		<ng-template #noLiftDataBlock>
			<div class="set_background_color_no_data">
				<div
					class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header no_lift_data_header"
				>
					<div class="o-stack__cell">
						<h5>{{ sectiontitle }}</h5>
					</div>
				</div>
				<div class="u-px-small no_lift_data_block stats_content">
					<div class="lift_stats_subhead">
						Campaigns in the selected date range are not eligible for lift reporting.
					</div>
					<div class="lift_stats_sub_section">
						<div class="lift_stats_subhead" style="padding-top: 5px">
							A campaign must meet all of the following 3 requirements to receive lift reporting:
						</div>
						<div>
							<ul class="lift_stats_list">
								<li>- Campaign must have the pixel placed and firing on the website</li>
								<li>- Campaign must run for 3 consecutive months</li>
								<li>- Campaign must run at least 50,000 audience extension impressions per month</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
